/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Carrier_In_DeliveryInputs */

const vi_order_action_carrier_in_delivery = /** @type {(inputs: Order_Action_Carrier_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giao (bên vận chuyển)`)
};

/**

* @param {Order_Action_Carrier_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_carrier_in_delivery = /** @type {((inputs?: Order_Action_Carrier_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Carrier_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_carrier_in_delivery(inputs)
});